import { sourceTruthMeta } from "./sourceTruth";

/**
 * SourceTruthBadge — renders one evidence-based source state. Presentation only: the state is
 * computed by classifySourceTruth from the query's own telemetry, never by this component.
 *
 * `truth` may be the object returned by classifySourceTruth or a bare SOURCE_TRUTH key.
 */
export default function SourceTruthBadge({ truth, className = "", testId }) {
  const meta = sourceTruthMeta(truth?.key ?? truth);
  const hint = truth?.hint ?? meta.hint;

  return (
    <span
      data-source-truth={meta.key}
      data-testid={testId}
      title={hint}
      aria-label={`מצב מקור: ${meta.label}`}
      className={`inline-flex items-center gap-1 text-[10px] px-1.5 py-0.5 rounded-full border font-medium whitespace-nowrap ${meta.cls} ${className}`}
    >
      <span aria-hidden="true" className="w-1 h-1 rounded-full bg-current opacity-70" />
      {meta.label}
    </span>
  );
}
